import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { ExperimentState } from 'modules/graphql';
import { StatusBadge } from 'modules/experiments/components/ui';
import { detailsMetadata } from 'modules/experiments/constants';
import { CardValueText, CardKeyText, StyledExperimentDetailsItem } from './Styled';

type ExperimentDetailsItemProps = {
  property: string;
  value: string | ExperimentState | null | boolean;
};

export const ExperimentDetailsItem = ({ property, value }: ExperimentDetailsItemProps) => {
  const { t } = useExperimentsTranslations();

  const CardValue =
    property === detailsMetadata.experimentState ? (
      <StatusBadge state={value as ExperimentState} />
    ) : (
      <CardValueText>{value}</CardValueText>
    );

  return (
    <StyledExperimentDetailsItem>
      <CardKeyText data-test={property}>{t(`detailsMetadata.${property}`)}</CardKeyText>
      <div data-test={`${property}-value`}>{CardValue}</div>
    </StyledExperimentDetailsItem>
  );
};
